


export class AuthorProfileView {

    constructor() {

        this.boxes = document.querySelectorAll('.topic_author');
		if (!this.boxes) { return false;}
    }

    render(state) { 

        if (!state) { return false;}
		
		if (!this.boxes) { return false;}

		const data = state.data;
		if (!data) { return false;}
		
		this.boxes.forEach((box) => {
			
			const a = box.querySelector('.title a');
			const avatar = box.querySelector('a.avatar');
			
			if (data.username) {
				a.textContent = data.username;
				avatar.querySelector('img').attr = data.username;
			}
			
			if (data.url) {
				a.href = data.url;
				avatar.href = data.url;
			}
			
			if (data.avatar) {
				avatar.querySelector('img').src = data.avatar;
			}
			
			if (data.role) {
				const roleEl = box.querySelector('.title > span');
				if (roleEl) { roleEl.textContent = data.role;}
			}
			
			const followButton = box.querySelector('.button.follow');
			if (followButton && data.followButton) {
				followButton.querySelector(':scope > span').textContent = data.followButton.title;
				followButton.classList.toggle('toggled', data.followButton.isActive);
			}
			
			if (data.counters) {
				
				const counterBox = box.querySelector('.counters');
				
				if (data.counters.publications) {
					const publications = data.counters.publications;
					
					const counter = counterBox.querySelector('.ci.posts > .b');
					if (counter) {

						counter.href = publications.url;
						counter.setAttribute('data-tooltip', publications.title);
						counter.querySelector(':scope > span').textContent = publications.value;
					}
				}
				
				if (data.counters.followers) {
					const followers = data.counters.followers;
					
					const counter = counterBox.querySelector('.ci.followers > .b');
					if (counter) { 
						
						counter.setAttribute('data-tooltip', followers.title);
						counter.querySelector(':scope > span').textContent = followers.value;
					}
				}
			}
			
			box.classList.remove('dummy');
		});
    }
}